import { UserResponse } from "../../user/user.model";

export class HitDimensions {
  public contentName: string;
  public videoName: string;
  public radioName: string;
  public sourceType: string;
  public sourceName: string;
  public provider: string;
  public artist: string;
  public album: string;
  public deeplinkType: string;
  public soundQuality: string;
  public janra: string;
}

export class UserDimensions {
  public gsmOperatorType: UserResponse['gsmOperator'];
  public isTurkcell: string;
  public soundQuality: UserResponse['settings']['songListenQuality'];
  public userId: UserResponse['msisdn'];
  public userPackage: string;
}

export class SessionDimensions {
  public loginStatus: StatusLabel;
  public isOnline = 'Online';
}

export enum StatusLabel {
  TRUE = 'True',
  FALSE = 'False'
}

export enum SuccessFailureLabel {
  SUCCESS = 'Success',
  FAILURE = 'Failure'
}

export enum PaymentMethodType {
  BILL = 'Phone Bill',
  CREDIT_CARD = 'Credit Card'
}

export class PageViewDimensions {
  public sourceName: string;
  public sourceType: string;
  public searchText?: string;
  public contentId?: string | number;
  public contentType?: string;
}

export interface IAnalyticsEvent {
  event?: string;
  eventCategory?: string;
  eventAction?: string;
  eventLabel?: string;
}

export interface VirtualEvent {
  event?: string;
  virtualPageURL?: string;
  virtualPageTitle?: string;
  language?: string;
}

export abstract class GAEvent implements IAnalyticsEvent {
  public event: string;
  public eventCategory: string;
  public eventAction: string;
  public eventLabel: string;

  public userPackage: string;
}

export class ProductImpressionEvent extends GAEvent {
  public event:string='view_item_list';
  public eventCategory:string='Enhanced Ecommerce';
  public eventAction:string='Impression';
  public eventLabel:string='';
  public ecommerce:Ecommerce;

  public userPackage: string;
  public errorType?:string;
}


export class ProductClickEvent extends GAEvent {
  public event:string = 'view_item';
  public eventCategory:string = 'Enhanced Ecommerce';
  public eventAction:string = 'Click';
  public eventLabel:string ='';
  public ecommerce:Ecommerce;

  public userPackage: string;
  public errorType?:string;

}

export class NewCreditCardEvent extends GAEvent {
  public event: string = 'GAEvent'
  public eventAction: string = 'New Credit Card';
  public eventCategory: string = 'Functions';
  public eventLabel: string = 'Success';

  public userPackage: string;
  public errorType?:string;
}

export class DeleteCreditCardEvent extends GAEvent {
  public event: string = 'delete_card'
  public eventAction: string = 'Delete Credit Card';
  public eventCategory: string = 'Functions';
  public eventLabel: string = 'Success';

  public userPackage: string;
  public errorType?:string;
}

export class AddCartEvent extends GAEvent {
  public event: string = 'begin_checkout'
  public eventAction: string = 'Add to Cart';
  public eventCategory: string = 'Enhanced Ecommerce';
  public eventLabel: string = 'Success';
  public ecommerce?: Ecommerce;

  public userPackage: string;
  public errorType?:string;
}

export class PurchaseEvent extends GAEvent {
  public event: string = 'purchase';
  public eventCategory: string = 'Enhanced Ecommerce';
  public eventAction: string='Purchase';
  public eventLabel:string;
  public ecommerce?: Ecommerce;

  public userPackage: string;
  public paymentMethod?: PaymentMethodType;
  public errorType?:string;


}

export class CancelPackageEvent extends GAEvent {
  public event: string = 'cancel_package';
  public eventCategory: string = 'Enhanced Ecommerce';
  public eventAction: string='Cancel Package';
  public eventLabel:string;
  public ecommerce?: Ecommerce;

  public userPackage: string;
  public paymentMethod?: PaymentMethodType;
  public errorType?:string;
}

export class Ecommerce {
  public currencyCode?: string;
  public purchase?:Purchase;
  public impressions?:Product[];
  public add?:Add;
  public click?:Click;

}

export class Click{
  public products? : Product[];
}

export class Add{
  public products?:Product[];
}

export class Purchase{
  public products?:Product[];
  public actionField?:ActionField;
}

export class ActionField {
  public id?: string;
  public revenue?: string;
}

export class Product{
  public name?:string;
  public id?:string;
  public price?:number;
  public brand?:string='fizy';
  public category?:string='';
  public variant?:string='Packages';
  public quantity?:number=0;
  public position?:number=1;
  public list?:string='';
  public affiliation?:string='';
  public revenue?:string;
  public tax?:string='';
  public shipping?:number = 0;
  public coupon?:string='';

}

export class ChangePaymentMethod extends GAEvent {
  public event: string = 'change_payment_method';
  public eventCategory: string = 'Enhanced Ecommerce';
  public eventAction: string='Change Payment Method';
  public eventLabel:string;
  public ecommerce?: Ecommerce;

  public userPackage: string;
  public paymentMethod?: PaymentMethodType;
  public errorType?:string;
}



// WEBPACK FOOTER //
// src/app/common/services/analytics/events/dimensions.ts